import {Button, Card, Form, Input} from 'antd'
import React from 'react'
import {useHistory} from 'react-router-dom'
import RetrieveSteps from './retrieve_steps'
import {LockOutlined} from '@ant-design/icons'
import API from 'api'
import {useEffect} from 'react'
import {useState} from 'react'
import {newUser, User} from 'api/user'

const passwordRules = [
  {
    require: true,
    message: '请输入新密码！',
  },
]
const confirmPasswordRules = [
  {
    require: true,
    message: '请确认密码！',
  },
  ({getFieldValue}) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('请输入相同的密码！'))
    },
  }),
]
const ResetCom = () => {
  const [user, setUser] = useState<User>(newUser())
  const history = useHistory()
  const resetPassword = values => {
    values.action = 'setPassword'
    if (values.newPassword !== undefined) {
      values.password = values.newPassword
    }
    values.user = {
      ...user,
    }
    delete values.newPassword
    delete values.queryPassword
    API.editUserInfo(values).then(res => {
      if (res.code === 200) {
        history.push('/retrieve/success')
      }
    })
  }
  useEffect(() => {
    let user = (history.location.state as any).user
    setUser(user)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <Card className="retrieve-form-card">
        <RetrieveSteps current={1} />

        <Form onFinish={resetPassword}>
          <Form.Item name="newPassword" rules={passwordRules} hasFeedback>
            <Input
              className="login-input"
              placeholder="新密码"
              size="large"
              autoComplete="new-password"
              prefix={<LockOutlined style={{color: '#BFBFBF'}} />}
            />
          </Form.Item>
          <Form.Item
            name="queryPassword"
            dependencies={['newPassword']}
            rules={confirmPasswordRules}
            hasFeedback
            style={{marginTop: 38}}
          >
            <Input
              className="login-input"
              placeholder="确认密码"
              size="large"
              autoComplete="new-password"
              prefix={<LockOutlined style={{color: '#BFBFBF'}} />}
            />
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              className="login-form-button"
              size="large"
              style={{marginTop: 16}}
            >
              下一步
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </>
  )
}

export default ResetCom
